import React, { useEffect, useMemo, useState } from "react";
import TitleUnderlined from "../components/TitleUnderlined";
import Divider from "../components/Divider";
import Row from "../components/Row";
import Column from "../components/Column";
import SpinnerButton from "../components/SpinnerButton";
import Button from "../components/Button";
import Form from "../components/Form";
import Utils from "../tools/Utils";
import { useNavigate } from "react-router-dom";
import Attendee from "../models/Attendee";
import Order from "../models/Order";
import APIInterface from "../tools/APIInterface";
import CloudError from "../tools/ClourError";
import { RoutesWeb } from "../tools/RoutesWeb";
import { DECANATO_OPTIONS } from "../tools/decanatos";
import { GROUP_REGISTRATION_ENABLED, REGISTRATION_CLOSED_MESSAGE } from "../tools/registrationFlags";

const SignupGroupView = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [municipios, setMunicipios] = useState([]);
    const [order, setOrder] = useState(() => {
        const initialOrder = new Order();
        initialOrder.attendees = [new Attendee()];
        return initialOrder;
    });
    const [orders, setOrders] = useState(null);
    const [selectedTicketsCount, setSelectedTicketsCount] = useState(1);
    const navigate = useNavigate();

    const historicalTicketTotal = useMemo(() => {
        if (!orders || !Array.isArray(orders)) return 0;
        return orders.reduce((sum, ord) => sum + ord.length, 0);
    }, [orders]);

    const token = localStorage.getItem('tokenGroup');

    useEffect(() => {
        if(!token) {
            navigate(RoutesWeb.LOGIN_GROUP);
        }
    })

    let today = new Date();

    const handleData = (e) => {
        let newOrder = {...order};
        if(e.target.name === 'state_id'){
            let _state = Utils.estados.filter((state) => state.clave === e.target.value)[0];
            newOrder.state = _state.nombre;
        } else if (e.target.name === 'attachment') {
            newOrder.decanatoAttachment = e.target.files && e.target.files.length ? e.target.files[0] : null;
        } else if (e.target.name.startsWith('phoneNumber_')) {
            const index = parseInt(e.target.name.split('_')[1]);
            const attendees = [...(newOrder.attendees || [])];
            if (!attendees[index]) {
                attendees[index] = new Attendee();
            }
            attendees[index] = {
                ...attendees[index],
                phoneNumber: e.target.value,
            };
            newOrder.attendees = attendees;
        } else if (e.target.name.startsWith('fullName_')) {
            const index = parseInt(e.target.name.split('_')[1]);
            const attendees = [...(newOrder.attendees || [])];
            if (!attendees[index]) {
                attendees[index] = new Attendee();
            }
            attendees[index] = {
                ...attendees[index],
                fullName: e.target.value,
            };
            newOrder.attendees = attendees;
        } else {
            newOrder[e.target.name] = e.target.value;
        }
        setOrder(newOrder);
    }

    if(orders === null) {
        APIInterface.orders(token)
        .then((response) => {
            if(response.data) {
                let newOrders = [];
                for (const [key, value] of Object.entries(response.data)) {
                    newOrders.push(value);
                }
                setOrders(newOrders);
            }
        })
        .catch((error) => {
            console.error(error);
            CloudError.error(error);
            if(error.response.status === 401){
                localStorage.removeItem('tokenGroup');
                localStorage.removeItem('userGroup');
                navigate(RoutesWeb.LOGIN_GROUP);
            }
        });
    }

    return (
        <div className="pt-5 pb-5">
            <Form 
            submitCallback={() => {
                if (!GROUP_REGISTRATION_ENABLED || isLoading) {
                    return;
                }

                setIsLoading(true);
                APIInterface.createOrder(token, order)
                .then((response) => {
                    if (response.status === 200) {
                        navigate('/registrar-grupo/gracias/' + Utils.encodeBase64((historicalTicketTotal + selectedTicketsCount).toString()));
                    }
                })
                .catch((error) => {
                    console.error(error);
                    CloudError.error(error);
                })
                .finally(() => {
                    setIsLoading(false);
                });
            }}>
                <TitleUnderlined>Registro de <span className="embercom_overlined">Grupo</span></TitleUnderlined>
                <br />
                <br />
                <br />
                <h5 className="text-uppercase"><b>Historial de registros</b></h5>
                <Divider style={{maxWidth: '350px', height: '2px'}} />
                <Row>
                    <Column className="col-md-6">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th className="border-0">Boletos</th>
                                    <th className="border-0">Fecha</th>
                                </tr>
                            </thead>
                            <tbody>
                                {orders !== null ? 
                                orders.map((ord, key) => {
                                    let dat = new Date(ord[0].order.created_at);
                                    return <tr key={key}>
                                    <td className="border-0">
                                        <div className="py-2">{ord.length}</div>
                                    </td>
                                    <td className="border-0">
                                        <Row className="border py-2">
                                            <Column className="col-6" strict>
                                                {Utils.formatDate(dat)}
                                            </Column>
                                            <Column className="col-6 text-right" strict>
                                                {dat.getHours() < 10 ? `0${dat.getHours()}` : dat.getHours() }:{dat.getMinutes() < 10 ? '0'+dat.getMinutes() : dat.getMinutes()} {dat.getHours() >= 12 ? 'pm' : 'am'}
                                            </Column>
                                        </Row>
                                    </td>
                                </tr>
                                })
                                :
                                <></>}
                            </tbody>
                        </table>
                    </Column>
                </Row>
                <br />
                <h5 className="text-uppercase"><b>Nuevo registro</b></h5>
                <Divider style={{maxWidth: '350px', height: '2px'}} />
                {!GROUP_REGISTRATION_ENABLED ? (
                    <p className="mt-2 mb-0">{REGISTRATION_CLOSED_MESSAGE}</p>
                ) : (
                    <>
                <p className="mt-2 mb-0 semibold">Indicar el número de personas:</p>
                <SpinnerButton className="mb-4" style={{maxWidth: '200px'}} onChange={(res) => {
                    setSelectedTicketsCount(res.value);
                    let attendees = [];
                    for(let i = 0; i < res.value; i++) {
                        attendees.push(new Attendee({
                            fullName: order.attendees && order.attendees[i] ? order.attendees[i].fullName : null,
                            phoneNumber: order.attendees && order.attendees[i] ? order.attendees[i].phoneNumber : null
                        }));
                    }
                    setOrder((prevOrder) => ({
                        ...prevOrder,
                        attendees,
                    }));
                }} />
                <br />
                {order.attendees && order.attendees.length > 0 ? (
                    <>
                        <h6 className="text-uppercase"><b>Datos por inscrito</b></h6>
                        <Divider style={{maxWidth: '350px', height: '2px'}} />
                        {order.attendees.map((attendee, idx) => (
                            <Row key={idx}>
                                <Column className="col-md-6">
                                    <div className="form-group">
                                        <label className="semibold" htmlFor={`fullName_${idx}`}>Inscrito {idx + 1} — Nombre completo</label>
                                        <input
                                            className="form-control"
                                            id={`fullName_${idx}`}
                                            type="text"
                                            autoComplete="name"
                                            required
                                            name={`fullName_${idx}`}
                                            value={order.attendees[idx]?.fullName || ''}
                                            onChange={handleData}
                                        />
                                    </div>
                                </Column>
                                <Column className="col-md-6">
                                    <div className="form-group">
                                        <label className="semibold" htmlFor={`phoneNumber_${idx}`}>Teléfono</label>
                                        <input
                                            className="form-control"
                                            id={`phoneNumber_${idx}`}
                                            type="text"
                                            required
                                            name={`phoneNumber_${idx}`}
                                            inputMode="numeric"
                                            autoComplete="tel-national"
                                            pattern="[0-9]{10}"
                                            maxLength={10}
                                            title="10 dígitos, solo números"
                                            value={order.attendees[idx]?.phoneNumber || ''}
                                            onChange={handleData}
                                        />
                                    </div>
                                </Column>
                            </Row>
                        ))}
                    </>
                ) : null}
                <br />
                <Row>
                    <Column className="col-md-4">
                        <div className="form-group">
                            <label htmlFor="state_id" className="semibold">Estado</label>
                            <select className="form-control" id="state_id" name="state_id" required onChange={(e) => {
                                handleData(e);
                                setMunicipios(Utils.municipios[e.target.value])
                            }}>
                                <option value="">Seleccione un estado</option>
                                {Utils.estados.map((estado, index) => {
                                    return (
                                        <option key={index} value={estado.clave}>{estado.nombre}</option>
                                    )
                                })}
                            </select>
                        </div>
                    </Column>
                    <Column className="col-md-4">
                        <div className="form-group">
                            <label htmlFor="city_id" className="semibold">Municipio</label>
                            <select className="form-control" id="city_id" name="city" required onChange={handleData}>
                                <option value="">Seleccione un municipio</option>
                                {municipios.map((municipio, index) => {
                                    return (
                                        <option key={index} value={municipio}>{municipio}</option>
                                    )
                                })}
                            </select>
                        </div>
                    </Column>
                </Row>
                <br />
                <h5 className="text-uppercase"><b>Carga</b></h5>
                <Divider style={{maxWidth: '350px', height: '2px'}} />
                <Row className="gy-4">
                    {/* <Column className="col-md-4 mb-2">
                        <div className="form-group">
                            <label htmlFor="period_year" className="semibold">Año</label>
                            <input className="form-control" type="number" min="2020" max="2100" required id="period_year" name="periodYear" value={order.periodYear || ''} onChange={handleData} />
                        </div>
                    </Column>
                    <Column className="col-md-4 mb-2">
                        <div className="form-group">
                            <label htmlFor="period_quincena" className="semibold">Quincena</label>
                            <select className="form-control" required id="period_quincena" name="periodQuincena" value={order.periodQuincena || 1} onChange={handleData}>
                                <option value="1">Primera</option>
                                <option value="2">Segunda</option>
                            </select>
                        </div>
                    </Column> */}
                    <Column className="col-md-8 mb-2">
                        <div className="form-group">
                            <label htmlFor="attachment" className="semibold">Adjunto de carga</label>
                            <input className="form-control" type="file" required accept=".jpg,.jpeg,.png,.pdf,.xlsx,.xls,.csv,.doc,.docx" id="attachment" name="attachment" onChange={handleData} />
                        </div>
                    </Column>
                    <Column className="col-md-8 mb-2">
                        <div className="form-group">
                            <label htmlFor="loadNotes" className="semibold">Observaciones</label>
                            <textarea className="form-control" id="loadNotes" name="loadNotes" rows="3" value={order.loadNotes || ''} onChange={handleData} />
                        </div>
                    </Column>
                </Row>
                <br />
                <Row>
                    <Column className="col-md-8">
                        <div className="form-group">
                            <label htmlFor="created_at" className="semibold">Fecha y hora presente de registro</label>
                            <p className="form-control mb-0 dis" style={{display: 'inline-flex'}}>
                                <span style={{width:'70%'}}>{Utils.formatDate(today)}</span>  
                                <span style={{width:'30%', borderLeft: '1px solid rgba(112, 112, 112, 0.27)'}}>{today.getHours() < 10 ? `0${today.getHours()}` : today.getHours() }:{today.getMinutes() < 10 ? '0'+today.getMinutes() : today.getMinutes()} {today.getHours() >= 12 ? 'pm' : 'am'}</span>
                            </p>
                        </div>
                    </Column>
                </Row>
                <br />
                <Row>
                    <Column className="col-md-8">
                        <div className="form-group">
                            <label htmlFor="decanato" className="semibold">Número de Decanato desde el que participa tu grupo</label>
                            <select className="form-control" required name="decanato" id="decanato" value={order.decanato || ''} onChange={handleData}>
                                <option value="">Seleccione un decanato</option>
                                {DECANATO_OPTIONS.map((decanato) => (
                                    <option key={decanato} value={decanato}>{decanato}</option>
                                ))}
                            </select>
                            <small>* En dado caso de no conocer a qué decanato pertenece tu grupo, favor de preguntar al Sacerdote encargado o al equipo de Re-Valorízate directamente</small>
                            {/* <input className="form-control" required type="text" name="decanato" id="decanato" onChange={handleData} /> */}
                        </div>
                    </Column>
                </Row>
                <br />
                <Row>
                    <Column className="col-md-8">
                        <div className="form-check">
                            <input type="checkbox" required className="form-check-input" id="acepto" />
                            <label className="form-check-label" for="acepto">Acepto que ya he recibido los abonos correspondientes de las personas indicadas.</label>
                        </div>
                        <div className="form-check">
                            <input type="checkbox" required className="form-check-input" id="confirmo" />
                            <label className="form-check-label" for="confirmo">Confirmo que todos los menores registrados en el grupo cuentan con carta responsiva firmada y una identificación oficial por parte de padre o tutor del participante</label>
                        </div>
                        <div className="form-check">
                            <input type="checkbox" required className="form-check-input" id="declaro" />
                            <label className="form-check-label" for="declaro">Declaro que, tratándose de participantes menores de edad registrados por este medio, cuento con la autorización previa de su padre, madre o tutor legal y con la documentación correspondiente cuando sea requerida por la organización.</label>
                        </div>
                    </Column>
                </Row>
                <br />
                <Button disabled={isLoading}>
                    {isLoading ? <><span className="spinner-border spinner-border-sm mr-4" style={{marginRight: '1rem'}} role="status" aria-hidden="true"></span>Enviando...</> : 
                        <>Completar registro <img src={require('../assets/arrow_next.png')} alt="arrowNext" /></>
                    }
                </Button>
                    </>
                )}
            </Form>
        </div>
    )
}

export default SignupGroupView;